import { getApiUrl } from './apiConfig';
import { getSupabaseProjectUrl, getCourseImagesBucketName } from './supabase';

/** Slug from display name for storage keys in the course editor: `{slug}_{sanitizedOriginalFileName}`. */
export function courseNameToFilePrefix(courseName) {
  const base = String(courseName ?? '')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return base || 'course';
}

export function buildSupabasePublicObjectUrl(projectUrl, bucket, objectPath) {
  const base = String(projectUrl || '').replace(/\/$/, '');
  if (!base || !bucket || !objectPath) return '';
  const cleanPath = String(objectPath).replace(/^\/+/, '');
  const encoded = cleanPath.split('/').map((seg) => encodeURIComponent(seg)).join('/');
  return `${base}/storage/v1/object/public/${bucket}/${encoded}`;
}

/**
 * Turn `course_media_display` entries into usable URLs.
 * Absolute URLs pass through; `/…` is resolved against the API; bare paths use the course images bucket.
 */
export function resolveCourseGalleryEntryToUrl(entry) {
  if (entry == null || typeof entry !== 'string') return '';
  const s = entry.trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith('/')) return `${getApiUrl()}${s}`;
  const projectUrl = getSupabaseProjectUrl();
  const bucket = getCourseImagesBucketName();
  if (!projectUrl || !bucket) return s;
  return buildSupabasePublicObjectUrl(projectUrl, bucket, s);
}

export function isSupabasePublicStorageObjectUrl(url) {
  if (!url || typeof url !== 'string') return false;
  return url.includes('/storage/v1/object/public/');
}

export function isSupabasePublicVideoUrl(url) {
  if (!isSupabasePublicStorageObjectUrl(url)) return false;
  const path = url.split('?')[0].toLowerCase();
  return /\.(mp4|webm|mov|m4v|mpeg|mpg)(\?|$)/i.test(path);
}
